// Librairies
import React from "react";
import { auth } from "./Authentication/Authentication";
// import $ from 'jquery';

export default class Page extends React.Component {
	componentDidMount() {
		// window.addEventListener('scroll', this.handleScroll);
		// $('html, body').animate(
		// 	{
		// 		scrollTop: 0
		// 	}
		// 	// 'slow'
		// );
		window.scrollTo(0, 0);
		// console.log(this.props.privateRoute);
		auth.updateAuthorities();
	}

	componentWillUnmount() {
		// window.removeEventListener('scroll', this.handleScroll);
	}

	// handleScroll(event) {}
}
